import type { TranslationMessages } from '../../types';

export const shift_switching: TranslationMessages = {
  title: 'Đổi ca',
  subtitle:
    'Yêu cầu và quản lý việc đổi ca của bạn với các thành viên nhân viên khác',
  live_updates: 'Cập nhật trực tiếp',
  offline: 'Ngoại tuyến',
  tab_my_requests: 'Yêu cầu của tôi',
  tab_received_requests: 'Yêu cầu đã nhận',
  tab_available_shifts: 'Ca làm việc có sẵn',
  create_request: 'Tạo yêu cầu',
  my_requests_title: 'Yêu cầu đổi ca của tôi',
  my_requests_description:
    'Các yêu cầu bạn đã thực hiện để đổi ca với các thành viên nhân viên khác',
  received_requests_title: 'Yêu cầu đổi ca đã nhận',
  received_requests_description:
    'Các yêu cầu từ các thành viên nhân viên khác để đổi ca với bạn',
  available_shifts_title: 'Ca làm việc có sẵn để đổi',
  available_shifts_description:
    'Các ca làm việc có sẵn để đổi với các thành viên nhân viên khác',
  loading_requests: 'Đang tải yêu cầu của bạn...',
  loading_received: 'Đang tải yêu cầu đã nhận...',
  loading_shifts: 'Đang tải ca làm việc có sẵn...',
  no_requests: 'Không tìm thấy yêu cầu đổi ca nào',
  no_received: 'Không tìm thấy yêu cầu đã nhận nào',
  no_available_shifts: 'Không có ca làm việc nào có sẵn để đổi',
  request_card_title: 'Yêu cầu đổi ca',
  your_shift: 'Ca làm việc của bạn',
  requested_shift: 'Ca làm việc đã yêu cầu',
  target_shift: 'Ca làm việc mục tiêu',
  from: 'Từ:',
  to: 'Đến:',
  reason: 'Lý do:',
  accept: 'Chấp nhận',
  reject: 'Từ chối',
  cancel_request: 'Hủy yêu cầu',
  status_pending: 'Đang chờ',
  status_accepted: 'Đã chấp nhận',
  status_rejected: 'Đã từ chối',
  status_cancelled: 'Đã hủy',
  unassigned: 'Chưa được giao',
  failed_load_requests: 'Không thể tải yêu cầu đổi ca của bạn',
  error_load_requests: 'Lỗi khi tải yêu cầu đổi ca của bạn',
  failed_load_received: 'Không thể tải yêu cầu đổi ca đã nhận',
  error_load_received: 'Lỗi khi tải yêu cầu đổi ca đã nhận',
  failed_load_shifts: 'Không thể tải ca làm việc của bạn',
  error_load_shifts: 'Lỗi khi tải ca làm việc của bạn',
  failed_load_available: 'Không thể tải ca làm việc có sẵn',
  error_load_available: 'Lỗi khi tải ca làm việc có sẵn',
  failed_load_staff: 'Không thể tải thành viên nhân viên',
  error_load_staff: 'Lỗi khi tải thành viên nhân viên',
  accept_success: 'Yêu cầu đổi ca đã được chấp nhận thành công!',
  accept_failed: 'Không thể chấp nhận yêu cầu',
  accept_error: 'Lỗi khi chấp nhận yêu cầu đổi ca',
  reject_success: 'Yêu cầu đổi ca đã bị từ chối',
  reject_failed: 'Không thể từ chối yêu cầu',
  reject_error: 'Lỗi khi từ chối yêu cầu đổi ca',
  cancel_success: 'Yêu cầu đổi ca đã bị hủy',
  cancel_failed: 'Không thể hủy yêu cầu',
  cancel_error: 'Lỗi khi hủy yêu cầu đổi ca',
  create_success: 'Yêu cầu đổi ca đã được tạo thành công!',
  create_failed: 'Không thể tạo yêu cầu',
  create_error: 'Lỗi khi tạo yêu cầu đổi ca',
  form_title: 'Tạo yêu cầu đổi ca',
  form_select_your_shift: 'Chọn ca làm việc của bạn',
  form_select_your_shift_desc: 'Chọn ca làm việc bạn muốn đổi từ',
  form_select_target_shift: 'Chọn ca làm việc mục tiêu',
  form_select_target_shift_desc: 'Chọn ca làm việc bạn muốn đổi sang',
  form_select_target_staff: 'Chọn nhân viên mục tiêu',
  form_select_target_staff_desc: 'Chọn người bạn muốn đổi ca cùng (tùy chọn)',
  form_review: 'Xem lại yêu cầu',
  form_review_desc: 'Xác nhận yêu cầu đổi ca của bạn',
  form_no_shifts: 'Không có ca làm việc nào có sẵn để đổi',
  form_no_available: 'Không có ca làm việc nào có sẵn để đổi',
  form_open_request: 'Yêu cầu mở',
  form_open_request_desc: 'Bất kỳ ai cũng có thể nhận ca làm việc này',
  form_reason_label: 'Lý do (Tùy chọn)',
  form_reason_placeholder: 'Tại sao bạn muốn đổi ca?',
  form_select_both: 'Vui lòng chọn cả hai ca làm việc',
  form_creating: 'Đang tạo...',
  form_create_request: 'Tạo yêu cầu',
  form_next: 'Tiếp theo',
  form_back: 'Quay lại',
  form_cancel: 'Hủy',
};
